import { messageFromError, toast } from '@eo/shared';

import { useAppDispatch } from '../../app/store';
import { logout } from '../../auth/logout';
import { saveName } from '../../staff/slice';
import { BasicInformationCard } from './BasicInformationCard';
import { SecurityCard } from './SecurityCard';
import type { AccountPanelProps } from './types';

export function AccountPanel({ me }: AccountPanelProps) {
  const dispatch = useAppDispatch();

  const onSaveName = async (name: string) => {
    try {
      await dispatch(saveName(name)).unwrap();
      toast.success('Profile updated.');
    } catch (err) {
      toast.error(messageFromError(err, 'Saving your profile failed. Try again.'));
    }
  };

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col justify-center gap-2">
        <h2 className="text-xl text-text-primary">Profile</h2>
        <p className="text-sm text-text-tertiary">
          Update how you appear across Mission Control, and manage this session.
        </p>
      </div>

      <div className="flex max-w-[1600px] flex-col gap-8 xl:flex-row xl:items-stretch">
        <BasicInformationCard me={me} onSaveName={onSaveName} />
        <SecurityCard onSignOut={() => void logout()} />
      </div>
    </div>
  );
}
